<template>
  <div>
    <m-feature-enable-switch feature="content" />
    <v-card class="pa-4">
      <v-combobox v-model="tags" chips deletable-chips hide-details label="Tags" multiple outlined></v-combobox>
      <v-divider class="mb-4"></v-divider>
      <v-btn color="button" depressed @click="save">Save</v-btn>
    </v-card>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
import { ChangeFeatureConfig, TenantState } from '@/store/tenant';
import MFeatureEnableSwitch from '@/components/Settings/MSettingsFeatures/MFeatureEnableSwitch';

export default Vue.extend({
  name: 'm-settings-features-content',
  components: { MFeatureEnableSwitch },
  data: () => ({
    tags: [],
  }),
  computed: {
    ...mapState<TenantState>('tenant', {
      tenant: (state: TenantState) => state.tenant,
    }),
    ...mapGetters('tenant', {
      featureConfig: 'featureConfig',
    }),
    contentConfig() {
      return this.featureConfig('content');
    },
  },
  mounted() {
    this.updateData();
  },
  methods: {
    async save() {
      if (
        JSON.stringify([...this.tags].sort()) !==
        JSON.stringify([...(Array.isArray(this.contentConfig.tags) ? this.contentConfig.tags : [])].sort())
      ) {
        await this.$store.dispatch(new ChangeFeatureConfig(this.tenant, 'content', { tags: this.tags }));
      }
    },
    updateData() {
      this.tags = [...(Array.isArray(this.contentConfig.tags) ? this.contentConfig.tags : [])];
    },
  },
});
</script>
